import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CpqMultiListBoxData, CpqMultiListBoxResult } from '../cpq-multi-list-box-with-recursion/cpq-multi-list-box-with-recursion.model';
import { MultiListBoxItem } from '../cpq-multi-list-box-with-selection/multi-list-box-item.model';
import { TranslationService } from '../common/services/translation.service';

@Component({
    selector: 'cpq-multi-list-box-with-recursion-dialog',
    templateUrl: './cpq-multi-list-box-with-recursion-dialog.component.html',
    styleUrls: ['./cpq-multi-list-box-with-recursion-dialog.component.scss'],
    standalone: false
})
export class CpqMultiListBoxWithRecursionDialogComponent implements OnInit {
  public selectedItems = new Array<MultiListBoxItem>();
  public hasSelectedChildrenTooltipText: string;
  public applyPermissions: boolean = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: CpqMultiListBoxData,
    public dialogRef: MatDialogRef<CpqMultiListBoxWithRecursionDialogComponent>,
    public translationService: TranslationService
  ) { }


  ngOnInit(): void {
    this.hasSelectedChildrenTooltipText = this.translationService.translate('Admin.ParentCategoryHasSelectedChildren');
  }

  public save() {
    let result = new CpqMultiListBoxResult();
    result.applyParentPermissions = this.applyPermissions;
    result.selectedItemsIds = this.selectedItems;
    this.dialogRef.close(result);
  }

  public close() {
    this.dialogRef.close(null);
  }
}

